import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import { useDatasourceAnalyticsEvents } from '../../../../../analytics';
import { asyncPopupSelectMessages } from './messages';
var ShowMoreButton = function ShowMoreButton(_ref) {
  var onShowMore = _ref.onShowMore,
    filterName = _ref.filterName;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  var handleShowMore = useCallback(function () {
    fireEvent('ui.button.clicked.basicSearchDropdown', {
      filterName: filterName,
      type: 'showMore'
    });
    onShowMore();
  }, [filterName, fireEvent, onShowMore]);
  return /*#__PURE__*/React.createElement(Button, {
    onClick: handleShowMore,
    appearance: "link",
    testId: "".concat(filterName, "--show-more-button")
  }, formatMessage(asyncPopupSelectMessages.showMoreMessage));
};
export default ShowMoreButton;